<ng-multiselect-dropdown [placeholder]="'Selecciona tag:'"
    [settings]="dropdownSettings" [data]="listTags" [(ngModel)]="selectedItems"
    (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeselect($event)"
    name="tag">
</ng-multiselect-dropdown>